<template>
  <div>
    <vue-recaptcha
      :class="{ 'hidden-captcha': isBudgeHidden }"
      v-show="!isBudgeHidden"
      ref="googleRecaptcha"
      :sitekey="sitekey"
      @verify="onVerify"
      @expired="onCaptchaExpired"
      badge="bottomleft"
      size="invisible"
      :loadRecaptchaScript="true"
    />
    <span :class="{ 'hidden-captcha': !isBudgeHidden }">
      {{$t('appCaptcha.websiteProtectedByReCaptcha')}}
      <a href="https://policies.google.com/privacy?hl=uk" target="_blank"
        >{{$t('appCaptcha.privacyPolicy')}}
      </a>
      та
      <a href="https://policies.google.com/terms?hl=uk" target="_blank">
        {{$t('appCaptcha.TermsOfUse')}}
      </a>
    </span>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
const siteKey = process.env.VUE_APP_RECAPTCHAKEY

export default {
  name: 'AppCaptcha',
  components: {
    VueRecaptcha
  },
  props: {
    isBudgeHidden: {
      default: () => false,
      type: Boolean
    }
  },
  data: () => ({
    sitekey: siteKey
  }),
  methods: {
    onVerify(response) {
      this.$emit('verify', response)
    },
    onCaptchaExpired() {
      console.log('Captcha expired')
      this.$refs.googleReacptcha.reset()
    },
    execute() {
      this.$refs.googleRecaptcha.execute()
    }
  }
}
</script>
<style lang="scss" scoped>
.hidden-captcha {
  visibility: hidden;
}
</style>
